import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { log } from 'node:console';
import { twJoin, twMerge } from 'tailwind-merge'

@Component({
    selector: 'app-accent-button',
    templateUrl: './accent-button.component.html',
    styleUrl: './accent-button.component.scss',
    standalone: false
})
export class AccentButtonComponent {
  @Input() text = '';
  @Input() selected = false;
  @Input() icon : any;
  
  get textClasses(): string {
    return twMerge( 'font-["Roboto-Regular"]', this.selected ? 'text-quaternary' : 'text-white');
  }
}
